/**
 * Endpoints for the dynamic shop-bff route
 */
export const OTHER_PRODUCTS_ENDPOINT = 'other-products';
export const ARTIST_SHOP_ARTIST_INFO_ENDPOINT = 'artist-shop-info';
export const ARTIST_INVENTORY_ITEM_PORTFOLIO_ENDPOINT =
  'artist-portfolio-items';

export const VALID_SHOP_BFF_ENDPOINTS = [
  OTHER_PRODUCTS_ENDPOINT,
  ARTIST_SHOP_ARTIST_INFO_ENDPOINT,
  ARTIST_INVENTORY_ITEM_PORTFOLIO_ENDPOINT,
];
